import api from '../services/api';
import apiWithJwt from '../services/apiWithJwt';
import { types } from '../store/constants/types';

export const emptyReduxSubscription = () => {
  return dispatch => {
    dispatch({type : types.CREATE_SUBSCRIPTION_PLAN_FAILED, payload : []})

    dispatch({type : types.GET_ALL_SUBSCRIPTION_PLAN_FAILED, payload : []})

    dispatch({type : types.GET_ALL_USER_SUBSCRIPTION_FAILED, payload : []})

    dispatch({type : types.CREATE_USER_SUBSCRIPTION_FAILED, payload : []})

    dispatch({type : types.UPDATE_SUBSCRIPTION_PLAN_FAILED, payload : []})

    dispatch({type : types.GET_SUBSCRIPTION_PLAN_FAILED, payload : []})
    
    dispatch({type : types.DELETE_SUBSCRIPTION_PLAN_FAILED, payload : []})

    dispatch({type : types.UPDATE_USER_SUBSCRIPTION_FAILED, payload : []})

    dispatch({type : types.GET_USER_SUBSCRIPTION_FAILED, payload : []})
    
    dispatch({type : types.DELETE_USER_SUBSCRIPTION_FAILED, payload : []})
  }
}

export const getAllSubscriptions = (perPage = 10, currentPage = 1) => {


  let queryParams = `?perPage=${perPage}&currentPage=${currentPage}`;

  return (dispatch) => {
    const apiWithToken = apiWithJwt(localStorage.token);
    apiWithToken.get('/subscription/plans'+queryParams)
      .then((response) => {
        dispatch({ type: types.GET_ALL_SUBSCRIPTION_PLAN_SUCCESS, payload: response.data });
      })
      .catch((error) => {
        dispatch({ type: types.GET_ALL_SUBSCRIPTION_PLAN_FAILED, payload: (error.response.data)});
      });
  };
};

export const resetGetAllSubscriptions = () => {
  return dispatch => {
    dispatch({type : types.GET_ALL_SUBSCRIPTION_PLAN_SUCCESS, payload : []})
}};

export const getSubscriptionById = (id) => {
  return (dispatch) => {
    const apiWithToken = apiWithJwt(localStorage.token);
    apiWithToken.get('/subscription/plan/'+id)
      .then((response) => {
        dispatch({ type: types.GET_SUBSCRIPTION_PLAN_SUCCESS, payload: response.data });
      })
      .catch((error) => {
        dispatch({ type: types.GET_SUBSCRIPTION_PLAN_FAILED, payload: (error.response.data)});
      });
  };
};

export const resetGetSubscriptionById = () => {
  return dispatch => {
    dispatch({type : types.GET_SUBSCRIPTION_PLAN_SUCCESS, payload : []})
}};

export const createSubscription = (data) => {
  return (dispatch) => {
    const apiWithToken = apiWithJwt(localStorage.token);
    apiWithToken.post('/subscription/plan/create', data)
      .then((response) => {
        dispatch({ type: types.CREATE_SUBSCRIPTION_PLAN_SUCCESS, payload: response.data });
      })
      .catch((error) => {
        dispatch({ type: types.CREATE_SUBSCRIPTION_PLAN_FAILED, payload: (error.response.data)});
      });
  };
};

export const resetcreateSubscription = () => {
  return dispatch => {
     dispatch({type : types.CREATE_SUBSCRIPTION_PLAN_SUCCESS, payload : []})
}};

export const updateSubscription = (id, data) => {
  return (dispatch) => {
    const apiWithToken = apiWithJwt(localStorage.token);
    apiWithToken.put(`/subscription/plan/update/${id}`, data)
      .then((response) => {
        dispatch({ type: types.UPDATE_SUBSCRIPTION_PLAN_SUCCESS, payload: response.data });
      })
      .catch((error) => {
        dispatch({ type: types.UPDATE_SUBSCRIPTION_PLAN_FAILED, payload: (error.response?.data || error.message) });
      });
  };
};

export const resetUpdateSubscription = () => {
  return dispatch => {
    dispatch({ type: types.UPDATE_SUBSCRIPTION_PLAN_SUCCESS, payload: [] });
  };
};

export const deleteSubscriptionPlanById = (planId) => {
  return (dispatch) => {
    const apiWithToken = apiWithJwt(localStorage.token);
    apiWithToken.delete(`/subscription/plan/delete/${planId}`)
      .then((response) => {
        dispatch({ type: types.DELETE_SUBSCRIPTION_PLAN_SUCCESS, payload: response.data });
      })
      .catch((error) => {
        dispatch({ type: types.DELETE_SUBSCRIPTION_PLAN_FAILED, payload: (error.response.data)});
      });
  };
};

/*
*
*  User Subscription Actions ======================================>>>
*
*/
export const getAllUserSubscription = (perPage = 10, currentPage = 1) => {

  let queryParams = `?perPage=${perPage}&currentPage=${currentPage}`;

  return (dispatch) => {
    const apiWithToken = apiWithJwt(localStorage.token);
    apiWithToken.get('/subscription/users'+queryParams)
      .then((response) => {
        dispatch({ type: types.GET_ALL_USER_SUBSCRIPTION_SUCCESS, payload: response.data });
      })
      .catch((error) => {
        dispatch({ type: types.GET_ALL_USER_SUBSCRIPTION_FAILED, payload: (error.response.data)});
      });
  };
};

export const resetGetAllUserSubscription = () => {
  return dispatch => {
    dispatch({type : types.GET_ALL_USER_SUBSCRIPTION_SUCCESS, payload : []})
}};

export const getUserSubscriptionByPlanId = (planId) => {
  return (dispatch) => {
    const apiWithToken = apiWithJwt(localStorage.token);
    apiWithToken.get('/subscription/users/filterbyplan/'+planId)
      .then((response) => {
        dispatch({ type: types.GET_USER_SUBSCRIPTIONS_By_PLAN_ID_SUCCESS, payload: response.data });
      })
      .catch((error) => {
        dispatch({ type: types.GET_USER_SUBSCRIPTIONS_By_PLAN_ID_FAILED, payload: (error.response.data)});
      });
  };
};

export const resetGetUserSubscriptionByPlanId = () => {
  return dispatch => {
    dispatch({type : types.GET_USER_SUBSCRIPTIONS_By_PLAN_ID_SUCCESS, payload : []})
}};


export const getUserSubscriptionByUserId = (userId) => {
  return (dispatch) => {
    const apiWithToken = apiWithJwt(localStorage.token);
    apiWithToken.get('/subscription/users/filterbyuser/'+userId)
      .then((response) => {
        dispatch({ type: types.GET_USER_SUBSCRIPTIONS_By_PLAN_ID_SUCCESS, payload: response.data });
      })
      .catch((error) => {
        dispatch({ type: types.GET_USER_SUBSCRIPTIONS_By_PLAN_ID_FAILED, payload: (error.response.data)});
      });
  };
};

export const resetGetUserSubscriptionByUserId = () => {
  return dispatch => {
    dispatch({type : types.GET_USER_SUBSCRIPTIONS_By_PLAN_ID_SUCCESS, payload : []})
}};



export const createUserSubscription = (data) => {
  return (dispatch) => {
    const apiWithToken = apiWithJwt(localStorage.token);
    apiWithToken.post('/subscription/user/create', data)
      .then((response) => {
        dispatch({ type: types.CREATE_USER_SUBSCRIPTION_SUCCESS, payload: response.data });
      })
      .catch((error) => {
        dispatch({ type: types.CREATE_USER_SUBSCRIPTION_FAILED, payload: (error.response.data)});
      });
  };
};

export const resetCreateUserSubscription = () => {
  return dispatch => {
     dispatch({type : types.CREATE_USER_SUBSCRIPTION_SUCCESS, payload : []})
}};


export const updateUserSubscription = (id, data) => {
  return (dispatch) => {
    const apiWithToken = apiWithJwt(localStorage.token);
    apiWithToken.put(`/subscription/user/update/${id}`, data)
      .then((response) => {
        dispatch({ type: types.UPDATE_USER_SUBSCRIPTION_SUCCESS, payload: response.data });
      })
      .catch((error) => {
        dispatch({ type: types.UPDATE_USER_SUBSCRIPTION_FAILED, payload: (error.response?.data || error.message) });
      });
  };
};

export const resetUpdateUserSubscription = () => {
  return dispatch => {
     dispatch({type : types.UPDATE_USER_SUBSCRIPTION_SUCCESS, payload : []})
}};

export const getUserSubscriptionById = (id) => {
  return (dispatch) => {
    const apiWithToken = apiWithJwt(localStorage.token);
    apiWithToken.get('/subscription/user/'+id)
      .then((response) => {
        dispatch({ type: types.GET_USER_SUBSCRIPTION_SUCCESS, payload: response.data });
      })
      .catch((error) => {
        dispatch({ type: types.GET_USER_SUBSCRIPTION_FAILED, payload: (error.response.data)});
      });
  };
};

export const resetGetUserSubscriptionById = () => {
  return dispatch => {
    dispatch({type : types.GET_USER_SUBSCRIPTION_SUCCESS, payload : []})
}};

export const deleteUserSubscriptionById = (Id) => {
  return (dispatch) => {
    const apiWithToken = apiWithJwt(localStorage.token);
    apiWithToken.delete(`/subscription/user/delete/${Id}`)
      .then((response) => {
        dispatch({ type: types.DELETE_USER_SUBSCRIPTION_SUCCESS, payload: response.data });
      })
      .catch((error) => {
        dispatch({ type: types.DELETE_USER_SUBSCRIPTION_FAILED, payload: (error.response.data)});
      });
  };
};